import React, { useRef, useEffect } from 'react';
import { gameDrawer } from './GameDrawer';
import { useGameContext } from './useGameContext';
import { Popup } from '../components/popup/popup';
import { GameApplicationType } from '../core/enums';
// import { GameApplicationType } from '../core/enums';
// import { GAME_APPLICATION_TYPE_STATE } from '../stateManagment';
// import { innerHeight } from 'bog-arcade-core-ui/helpers';
// import { GAME_APPLICATION_TYPE_STATE } from '../stateManagment';
// import { GameApplicationType } from '../core/enums';

// const big_win = document.getElementById('big_root');

// big_win.addEventListener('touchmove', (event) => {
//     document.body.requestFullscreen().catch(err => {
//     })
// }, {passive:true});

export const Game = ({ children }) => {
  const game = useRef(null);
  const { mode, scene, prevScene } = useGameContext(null);

  // useEffect(() => {
  //   let event = () => {
  //     if (document.fullscreenElement) {
  //       big_win.style.display = 'none';
  //     } else {
  //       big_win.style.display = 'block';
  //     }
  //   };
  //   const gameApplicationTypeStateObserver = GAME_APPLICATION_TYPE_STATE.subscribe(applicationType => {
  //     if (applicationType !== GameApplicationType.web) {
  //       document.addEventListener('fullscreenchange', event);
  //     } else {
  //       big_win.style.display = 'none';
  //     }
  //   }, true);
  //   return () => {
  //     gameApplicationTypeStateObserver.unsubscribe();
  //     document.removeEventListener('fullscreenchange', event);
  //   };
  // }, []);

  useEffect(() => {
    if (game.current) {
      const { height } = game.current.getBoundingClientRect();
      // alert(innerHeight() + '___' + height + '----' + window.innerHeight);
      gameDrawer.execute(game.current);
    }
  }, [game]);

  useEffect(() => {
    if (game.current) {
      gameDrawer.modeChange({ mode, scene, prevScene });
    }
  }, [mode, game, scene, prevScene]);

  return (
    <section
      ref={game}
      className={`game__parent ${mode === GameApplicationType.mobile ? 'mobile' : ''}`}
    >
      {children}
      <Popup/>
    </section>
  );
};
